import Vue from "vue";
import Router from "vue-router";
import Dashboard from './components/Dashboard.vue';
import Login from './components/Login.vue';
import Users from './components/Users.vue';
import Menu from './components/Menu.vue';
import Menumanage from './components/Menumanage.vue';
import Url from './components/Url.vue';
import Home from './components/Home.vue';
import QrcodeWeb from './components/QrcodeWeb.vue';
import Calendar from './components/Calendar.vue';
import EditorHTML from './components/EditorHTML.vue';
import paginate from './components/paginate.vue';
import Map from './components/Map.vue';
import Detail from './components/Detail.vue';

Vue.use(Router);
const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/Dashboard",
      alias: "/Dashboard",
      name: "Dashboard",
      component: Dashboard
    },
    {
      path: "/login",
      alias: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/Users",
      alias: "/Users",
      name: "Users",
      component: Users
    },
    {
      path: "/menu",
      alias: "/menu",
      name: "menu",
      component: Menu
    },
    {
      path: "/menumanage",
      alias: "/menumanage",
      name: "menumanage",
      component: Menumanage
    },
    {
      path: "/url",
      alias: "/url",
      name: "url",
      component: Url
    },
    {
      path: "/",
      alias: "/home",
      name: "home",
      component: Home
    },
    {
      path: "/qrcode",
      alias: "/qrcode",
      name: "qrcode",
      component: QrcodeWeb
    },
    {
      path: "/Calendar",
      alias: "/Calendar",
      name: "Calendar",
      component: Calendar
    },
    {
      path: "/editorhtml",
      alias: "/editorhtml",
      name: "editorhtml",
      component: EditorHTML
    },
    {
      path: "/paginate",
      alias: "/paginate",
      name: "paginate",
      component: paginate
    },
    {
      path: "/map",
      alias: "/map",
      name: "map",
      component: Map
    },
    {
      path: "/detail/:id",
      alias: "/detail",
      name: "detail",
      component: Detail
    }
  ]
});


router.beforeEach((to, from, next) => {
  const publicPages = ['/login','/home','/qrcode'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('mhotspot');
  // trying to access a restricted page + not logged in
  // redirect to login page
  // console.log(loggedIn);
  if (authRequired && !loggedIn) {
    next('/login');
    // next();
  } else {
    next();
  }

});

export default router;
